import { render, staticRenderFns } from "./LikeBtn.vue?vue&type=template&id=3bbe8904&"
import script from "./LikeBtn.vue?vue&type=script&lang=js&"
export * from "./LikeBtn.vue?vue&type=script&lang=js&"
import style0 from "./LikeBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports